import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import sv from 'vuetify/lib/locale/sv'

export default new Vuetify({
  lang: {
    locales: { sv },
    current: 'sv'
  },
  theme: {
    themes: {
      light: {
        primary: '#c3a66c',
        secondary: '#778186',
        accent: '#8bb399',
        white: '#ffffff',
        developer: '#d972ff',
      }
    }
  }
});
